module.exports = __webpack_public_path__ + "img/design-architecture-icon.ce19bfbe.svg";